<template>
    <div class="app">
        <el-autocomplete style="width:200px;" size="small" v-model="query.name" clearable v-loading="loading" ref="autocomplete"
            v-scrollLoad="load" :fetch-suggestions="querySearch" placeholder="请输入学员名称" @select="handleSelect"
            @clear="ckearName">
            <template slot-scope="{ item }">
                <div class="name">{{ item.studentUserInfo.realname }} <span style="font-size: 12px; color: #b4b4b4;">{{
                    item.name }}</span>
                </div>
            </template>
        </el-autocomplete>
    </div>
</template>
<script>
// import { getData } from 'url路径';
import {
    getFormalStudentList1,
} from "@/api/educational";
export default {
    data() {
        return {
            loading: false,
            //请求参数
            query: {
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            //数据量计数
            suppilerListTotal: 0,
            //表单数据
            form: {}
        };
    },
    //自定义指令
    directives: {
        //用户选择栏的懒加载
        scrollLoad: {
            bind(el, binding, vnode) {
                //防抖函数
                function debounce(func, wait, immediate) {
                    //func函数，wait为时间周期
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function () {
                            timeout = null;
                            if (!immediate) {
                                func.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(context, args);
                        }
                    };
                }
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list');
                //将滚动事件通过参数传入防抖函数中
                var myEfficientFn = debounce(function () {
                    let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight;
                    if (condition > 0 && !vnode.context.loading) {
                        //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                        binding.value();
                    }
                }, 250);
                wrapDom.addEventListener('scroll', myEfficientFn, false); //绑定滚动事件
            }
        }
    },
    methods: {
        //滚到底部执行的方法
        load() {
            //如果数据量小于请求参数中的size，则表示请求数据已到底，无需继续请求
            if (this.query.pageNum * this.query.pageSize > this.suppilerListTotal) {
                return false;
            }
            this.loading = true;
            this.query.pageNum += 1; //滑到底后将pageSize+50，即为请求数量+50
            //getFormalStudentList1 -滚动到底部后发起请求
            getFormalStudentList1({
                realname: this.query.name,
                campusIds: JSON.stringify(this.$store.state.user.selected_schools),
                page_no: this.query.pageNum,
                page_size: this.query.pageSize,
            }).then(res => {
                this.suppilerListTotal = res.total; //将请求到的数组长度赋值给suppilerListTotal，用来存储数据量
                this.$refs['autocomplete'].$data.suggestions.push(...res.studentList); //将响应数据通过ref来进行实时更新
                this.loading = false;
            });
        },
        //新增用户时选择客户
        querySearch(queryString, cb) {
            //queryString为输入框的数据
            if (queryString) {
                //当输入框中有数据存在时
                this.query.name = queryString; //将数据赋给参数中的name
                this.query.pageNum = 1; // 将查询页数重置为1，以便重新开始查询
            } else {
                this.query.name = ''; //如果没值则将参数中的name赋空，防止二次选择，查不到全部的数据
                this.query.pageNum = 1;
            }
            //调用api接口
            getFormalStudentList1({
                realname: this.query.name,
                campusIds: JSON.stringify(this.$store.state.user.selected_schools),
                page_no: this.query.pageNum,
                page_size: this.query.pageSize,
            }).then(res => {
                this.suppilerListTotal = res.total; //将请求到的数组长度赋值给suppilerListTotal，用来存储数据量
                cb(res.studentList); //将响应数据中的数组通过cb回调函数传给组件
            });
        },
        //选择客户后将用户id传给表单
        handleSelect(item) {
            this.query.name = item.studentUserInfo.realname
            this.$emit("getUserId", item.id)
            this.$emit("getUserName", item)


            // this.formInline.student_user_id = item.id
            // this.form.id = item;
            // console.log(this.form.id, 45121);
        },
        ckearName(item) {
            console.log(item, 45451);
            if (item === undefined) {
                this.$emit("getUserId", '')
            }
        }
    }
};
</script>